/**
 * Kalkulátor section -- valós idejű diákbér / főállás / szolgáltatási díj számítás.
 *
 * A paraméterek a .kalkulator__card data-params JSON-jából jönnek
 * (DrewCore Beállítások → Kalkulátor paraméterek, évente frissítendő).
 * A számítási logika az ügyfél Excel-kalkulátorainak specifikációját követi.
 */
(function () {
  'use strict';

  var cards = document.querySelectorAll('.kalkulator__card');
  if (!cards.length) return;

  function formatFt(x) {
    return Math.round(x).toLocaleString('hu-HU') + ' Ft';
  }

  function formatNap(x) {
    return Math.round(x).toLocaleString('hu-HU') + ' nap';
  }

  /* ---- DIÁK: órabér × óraszám, 25 év alatt sávos SZJA-mentesség ---- */
  function calcDiak(P, v) {
    var brutto = v.oraber * v.oraszam;
    var szja = v.elmult25
      ? brutto * P.szjaKulcs
      : Math.max(0, brutto - P.u25Plafon) * P.szjaKulcs;
    return { brutto: brutto, szja: szja, netto: brutto - szja };
  }

  /* ---- FŐÁLLÁS: TB + SZJA + kedvezmény-jóváírások (Excel-hű kizárási logika) ---- */
  function calcFoallas(P, v) {
    var brutto = v.brutto;
    var tb = (v.nyugdijas || v.nappaliDiak) ? 0 : brutto * P.tbKulcs;
    var szja = brutto * P.szjaKulcs;

    var anyasagi = v.anya2gyerek || v.anya3gyerek || v.anya30alatt;
    var kedvSum =
      ((v.anya2gyerek && !v.anya30alatt) ? brutto * P.szjaKulcs : 0) +
      ((v.anya3gyerek && !v.anya2gyerek && !v.anya30alatt) ? brutto * P.szjaKulcs : 0) +
      ((v.szemelyi && !anyasagi) ? Math.min(brutto, P.szemelyiPlafon) * P.szjaKulcs : 0) +
      ((v.elsoHazas && !anyasagi) ? Math.min(brutto, P.elsoHazasPlafon) * P.szjaKulcs : 0) +
      ((v.u25 && !anyasagi) ? Math.min(brutto, P.u25Plafon) * P.szjaKulcs : 0) +
      // 30 év alatti anyák: a nemzetgazdasági átlagkereset plafonjáig (ügyfél, 2026-09-02)
      (v.anya30alatt ? Math.min(brutto, P.anya30Plafon) * P.szjaKulcs : 0);

    // A jóváírás nem haladhatja meg a ténylegesen levont SZJA-t (ügyfél, 2026-09-02)
    kedvSum = Math.min(kedvSum, szja);

    // Családi kedvezmény: adóalap-kedvezmény. A maradék SZJA-t csökkenti,
    // a felette lévő rész a TB-járulékból írható jóvá (családi járulékkedvezmény).
    var gyerek = v.csaladiGyerek || 0;
    var perFo = gyerek >= 3 ? P.csaladi3 : (gyerek === 2 ? P.csaladi2 : (gyerek === 1 ? P.csaladi1 : 0));
    var csaladiErtek = (gyerek * perFo) * P.szjaKulcs;
    var szjaMaradek = szja - kedvSum;
    var csaladiSzja = Math.min(csaladiErtek, szjaMaradek);
    var csaladiTb = Math.min(csaladiErtek - csaladiSzja, tb);
    var csaladi = csaladiSzja + csaladiTb;

    return {
      tb: tb,
      szja: szja,
      kedvSum: kedvSum,
      csaladi: csaladi,
      netto: brutto - tb - szja + kedvSum + csaladi
    };
  }

  /* ---- SZABADSÁG: Mt. 116-120. § éves alap- + pótszabadság (Excel-hű) ---- */
  function calcSzabadsag(P, v) {
    var kor = P.ev - v.szulEv;

    var eletkori = 0;
    P.szabSavok.forEach(function (sav) {
      if (kor >= sav[0]) { eletkori = sav[1]; }
    });

    var gyerekNap = 0;
    if (v.gyerek === 1) { gyerekNap = P.szabGyerek1; }
    else if (v.gyerek === 2) { gyerekNap = P.szabGyerek2; }
    else if (v.gyerek > 2) { gyerekNap = P.szabGyerekTobb; }

    var fogyatekosNap = Math.min(v.fogyatekos, v.gyerek) * P.szabFogyatekos;
    var megvaltozottNap = v.megvaltozott ? P.szabMegvaltozott : 0;

    return {
      alap: P.szabAlap,
      eletkori: eletkori,
      gyerekNap: gyerekNap,
      fogyatekosNap: fogyatekosNap,
      megvaltozottNap: megvaltozottNap,
      osszesNap: P.szabAlap + eletkori + gyerekNap + fogyatekosNap + megvaltozottNap
    };
  }

  /* ---- SZOLGÁLTATÁSI DÍJ: bérköltség + kormányrendeleti min. díjrész ---- */
  function calcSzolgaltatasi(P, v) {
    var kulcs = (v.munkakor === 'szakmai' || v.munkakor === 'mernoki')
      ? P.minDijGarantalt
      : P.minDijMinimalber;
    var haviOrak = v.letszam * v.hetiOra * P.hetekSzama;
    var berBrutto = haviOrak * v.oraber;
    var kormMinDij = haviOrak * kulcs;
    var osszesen = berBrutto + kormMinDij;
    return {
      berBrutto: berBrutto,
      kormMinDij: kormMinDij,
      osszesen: osszesen,
      osszesenAfa: osszesen * (1 + P.afaKulcs)
    };
  }

  cards.forEach(function (card) {
    var tipus = card.getAttribute('data-tipus') || 'diakber';
    var P;
    try {
      P = JSON.parse(card.getAttribute('data-params'));
    } catch (e) {
      return;
    }

    var inputs = Array.prototype.slice.call(card.querySelectorAll('[data-kalk]'));
    var oraberDirty = false; // szolgáltatási: kézzel átírt órabért nem írjuk felül

    function readValues() {
      var v = {};
      inputs.forEach(function (el) {
        var name = el.getAttribute('data-kalk');
        if (el.type === 'checkbox') {
          v[name] = el.checked;
        } else if (el.type === 'radio') {
          if (el.checked) { v[name] = el.value === '1'; }
        } else if (el.tagName === 'SELECT') {
          v[name] = el.value;
        } else {
          v[name] = parseFloat(el.value) || 0;
        }
      });
      return v;
    }

    function write(res) {
      var fmt = (tipus === 'szabadsag') ? formatNap : formatFt;
      Object.keys(res).forEach(function (key) {
        var out = card.querySelector('[data-out="' + key + '"]');
        if (out) { out.textContent = fmt(res[key]); }
      });
    }

    function recalc() {
      var v = readValues();
      if (tipus === 'foallas') {
        write(calcFoallas(P, v));
      } else if (tipus === 'szolgaltatasi') {
        write(calcSzolgaltatasi(P, v));
      } else if (tipus === 'szabadsag') {
        write(calcSzabadsag(P, v));
      } else {
        write(calcDiak(P, v));
      }
    }

    inputs.forEach(function (el) {
      var evt = (el.type === 'checkbox' || el.type === 'radio' || el.tagName === 'SELECT') ? 'change' : 'input';
      el.addEventListener(evt, recalc);

      // Szolgáltatási: munkakör-váltáskor átlag órabér előtöltése, amíg nem írták át kézzel
      if (tipus === 'szolgaltatasi' && el.getAttribute('data-kalk') === 'oraber') {
        el.addEventListener('input', function () { oraberDirty = true; });
      }
      if (tipus === 'szolgaltatasi' && el.getAttribute('data-kalk') === 'munkakor') {
        el.addEventListener('change', function () {
          if (oraberDirty) return;
          var oraberInput = card.querySelector('[data-kalk="oraber"]');
          var atlag = P.oraberek && P.oraberek[el.value];
          if (oraberInput && atlag) {
            oraberInput.value = atlag;
            recalc();
          }
        });
      }
    });

    recalc();
  });
})();
